import styled from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';

export const ValuesBackground = styled.div`
  background-color: ${({ theme }) => theme.colors.turquoise};
  width: 100%;
  overflow: hidden;

  @media ${sizes.tabletLandscape} {
    padding-top: 200px;
  }
`;

export const ValuesContainer = styled.div`
  padding-bottom: 76px;
  padding-top: 60px;

  @media ${sizes.tabletLandscape} {
    padding-top: 0px;
    padding-bottom: 100px;
  }
`;

export const Title = styled.h1`
  font-weight: 700;
  font-size: 24px;
  line-height: 40px;
  box-sizing: content-box;
  color: ${th('colors.black')};
  max-width: 1260px;
  width: 100%;
  margin: 0px auto 32px auto;
  padding: 0px 20px;

  @media ${sizes.desktop} {
    margin: 0px auto 30px auto;
  }

  @media ${sizes.tabletLandscape} {
    font-size: 32px;
    line-height: 44px;
    padding: 0px 40px;
  }
`;
